import { useDispatch, useSelector } from 'react-redux';
import { useContext } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { reviewActions } from '../../store/review-slice';
import { useState } from 'react';
import { debounce } from 'lodash';
import Button from '../ui/Button';
import CreatableSelect from 'react-select/creatable';
import AuthContext from '../../store/auth-context';

import './BillingGridReviewForm.scss';

const BillingGridReviewForm = () => {
	const authCtx = useContext(AuthContext);

	const sponsorOptions = [
		{
			value: authCtx.userData.n || 'n/a',
			label: authCtx.userData.n || 'N/A'
		},
		{
			value: authCtx.userData.s || 'n/a',
			label: authCtx.userData.s || 'N/A'
		},
		{
			value: authCtx.userData.nb || 'n/a',
			label: authCtx.userData.nb || 'N/A'
		}
	];
	const [value, setValue] = useState();
	const [options, setOptions] = useState(sponsorOptions);

	const dispatch = useDispatch();
	// bring the coordinates/points of the item that the user selected
	let reviewSlicePoints = useSelector(
		(state) => state.reviewsManager.activePoint
	);

	let tableNumber = useSelector(
		(state) => state.reviewsManager.tableIndex
	);

	let oldValue = useSelector(
		(state) => state.reviewsManager.oldValue
	);

	const [userComment, setUserComment] =
		useState('No comment');

	// sidebar for adding comments is shown whenever the user has selected an item
	const show = reviewSlicePoints.length > 0;

	const handleClose = () => {
		dispatch(reviewActions.removeActivePoint());
	};

	const inputReviewCommentHandler = debounce((value) => {
		setUserComment(value);
	}, 1000);

	const handleSaveComment = () => {
		// save comment to specific point
		dispatch(
			reviewActions.setElement({
				value: oldValue,
				comment: userComment,
				newValue: value.value,
				row: reviewSlicePoints[0],
				column: reviewSlicePoints[1],
				tableNumber
			})
		);
		// remove active point
		dispatch(reviewActions.removeActivePoint());

		// remove table index
		dispatch(reviewActions.removeTableIndex());

		// reset comment state
		setUserComment('No comment');
		setValue();
	};

	const createOption = (label) => ({
		label,
		value: label.toLowerCase().replace(/\W/g, '')
	});

	const handleCreate = (inputValue) => {
		const newOption = createOption(inputValue);
		setOptions((prev) => [...prev, newOption]);
		setValue(newOption);
	};

	return (
		<>
			<Offcanvas
				show={show}
				onHide={handleClose}
				placement='end'
			>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>Request review</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body className='request-review-grid-body'>
					<div className='request-review-grid-container'>
						<div className='input-container'>
							<h6>Add your comments here:</h6>
							<div className='form-floating'>
								<textarea
									className='form-control request-review-grid-comment-textarea'
									placeholder='Leave a comment here'
									id='floatingTextarea'
									rows='10'
									onChange={(e) =>
										inputReviewCommentHandler(
											e.target.value
										)
									}
								></textarea>
								<label htmlFor='floatingTextarea'>
									Comments
								</label>
								<br />
								<h6>Covered by</h6>
								<CreatableSelect
									isClearable
									options={options}
									onChange={(newValue) =>
										setValue(newValue)
									}
									oonCreateOption={handleCreate}
									value={value}
								/>
							</div>
						</div>

						<Button
							className='primary-button'
							onClick={handleSaveComment}
							disabled={!value}
						>
							Save Comment
						</Button>
					</div>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
};

export default BillingGridReviewForm;
